import { render, staticRenderFns } from "./flow_storage.vue?vue&type=template&id=1284d31a&scoped=true"
import script from "./flow_storage.vue?vue&type=script&lang=js"
export * from "./flow_storage.vue?vue&type=script&lang=js"
import style0 from "./flow_storage.vue?vue&type=style&index=0&id=1284d31a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1284d31a",
  null
  
)

export default component.exports